import Button from "~/components/ui/Button";
import { sendEvent } from "~/sdk/analytics";
import { useUI } from "~/sdk/useUI";
import { AnalyticsItem } from "@decocms/apps-commerce/types";

import { PROD_URL_HTTPS } from "~/utils/constants";

interface Props {
  loading: boolean;
  currency: string;
  total: number;
  items: AnalyticsItem[];
  translucentEffect?: boolean;
  isSearchVisible?: boolean;
}

function CartButton({
  loading,
  currency,
  total,
  items,
  translucentEffect,
  isSearchVisible,
}: Props) {
  const { displayCart } = useUI();
  const totalItems = items.reduce((sum, item) => sum + item.quantity, 0);
  // URL de assets estáticos — nunca deriva de globalThis.location: isso causa
  // mismatch de hidratação (SSR não tem `location`, cai no fallback; o
  // cliente usa a origem real do navegador, divergindo do servidor).
  const host = PROD_URL_HTTPS;

  const onClick = () => {
    sendEvent({
      name: "view_cart",
      params: { currency, value: total, items },
    });
    displayCart.value = true;
  };

  return (
    <div className="indicator">
      <span
        className={`right-0.5 top-[3px] md:right-0.5 rounded-full w-[18px] h-[18px] md:top-[3px] indicator-item badge badge-primary badge-sm bg-[#C18A58] border-[#C18A58] text-[#1A1A1A] ${
          isSearchVisible ? "visible-search" : ""
        }`}
      >
        {totalItems > 9 ? "9+" : totalItems}
      </span>

      <Button
        aria-label="Abrir carrinho"
        data-deco={displayCart.value && "open-cart"}
        loading={loading}
        renderEvenIfLoading
        onClick={onClick}
        className="flex items-center gap-2"
      >
        {/* <img> nativo, não o componente Image: esses ícones estáticos são
            pequenos demais pra precisar de otimização via CDN, e o proxy
            decoims.com está rejeitando (403) o domínio www.danielatombini.com.br
            como origem — provável allowlist de domínio não configurada pro
            site "dt" no admin da deco. Ver PLANO-REDESIGN.md. */}
        <img
          loading="lazy"
          fetchPriority="low"
          src={(
            translucentEffect
              ? `${host}/icon_shopping-bag-white.png`
              : `${host}/icon_shopping-bag-gray.png`
          )}
          width={24}
          height={24}
          alt="Carrinho"
          className={`cart-icon ${isSearchVisible ? "visible-search" : ""}`}
        />
      </Button>
    </div>
  );
}

export default CartButton;
